/**
 * Aura AGM (AUDITED · Sole Member — Corporate) preset
 *   (my_preset / sg / aura / agm-sole-corp) — 자체완결 모듈, 자체등록.
 *
 * 매칭 = task code CAU004 (Aura 접두어 CAU).
 *   priority 57 (agm 55 / agm-multi 56 보다 높게 — 코드 전용 매칭이라 충돌은 없지만 명시).
 * 배선: sg/aura/index.ts 가 이 모듈을 import 하면 로드 시 자동 등록.
 *
 * agm(개인 단독주주, s.184G)과 달리 **법인 단독주주**(지주회사):
 *   AGM Documents = DRW(Audited) · Notice of AGM(Audited) · Consent to Short Notice(대리인) · Minutes s.179(6).
 *   Controller Notice = 개인/법인 둘 다.
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAuraAgmSoleCorpPanel from './components/PreSetAuraAgmPanel.vue';
import { auraAgmSoleCorpFlow } from './chatflows/auraAgmFlow';

export { default as PreSetAuraAgmSoleCorpPanel } from './components/PreSetAuraAgmPanel.vue';
export { auraAgmSoleCorpFlow } from './chatflows/auraAgmFlow';

/** 공통코드 — Aura AGM (Audited, Sole Member Corporate) 은 CAU004 로 발급됨. */
export const AURA_AGM_SOLE_CORP_TASK_CODES: string[] = ['CAU004'];

export function matchesAuraAgmSoleCorp(sel: PreSetSelection): boolean {
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AURA_AGM_SOLE_CORP_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAuraAgmSoleCorpPreset(): void {
  registerChatFlow(auraAgmSoleCorpFlow);
  registerPanel({
    id: 'aura-agm-sole-corp',
    priority: 57,
    match: (sel) => matchesAuraAgmSoleCorp(sel),
    component: PreSetAuraAgmSoleCorpPanel,
    meta: { docType: 'SG_AGM_SOLE_CORP_PRE', studio: true },
  });
}

registerAuraAgmSoleCorpPreset();
